<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </div>
</template>
<script>
    export default {
        name: "Logout",

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        created() {
            this.$store.commit('loadingOn')

            this.$sessionService.logout()
              .then(() => {
                  this.$sessionService.remove();
                  return this.$router.replace({ name: 'login' });
              })
              .catch((error) => {
                  alert(error.response.data.error)
              })
              .finally(() => this.$store.commit('loadingOff'));
        },
    }
</script>
